<form *ngIf="caseServiceCauseFormGroup" [formGroup]="caseServiceCauseFormGroup">
    <p-card class="p-3" header="Datos generales">
        <div class="grid">
            <div class="col-8 input-field">
                <label for="name">Nombre *</label>
                <input pInputText formControlName="name" d-form-field-error />
            </div>
            <div class="col-4 input-field">
                <label for="caseServiceCauseType">Tipo</label>
                <p-dropdown [options]="caseServiceCauseTypes" formControlName="caseServiceCauseType"
                    optionValue="value" [filter]="true" filterBy="label" optionLabel="label"
                    placeholder="Seleccione tipo" d-form-field-error />
            </div>
        </div>

        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button label="Eliminar" *ngIf="allowDelete" icon="pi pi-trash" styleClass="p-button-danger"
                (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    </p-card>
    <p-tabView *ngIf="caseServiceCause.id">
        <p-tabPanel header="MOTIVOS">
        <p-card>
            <div class="flex justify-content-end mb-2">
                <p-button *ngIf="allowWrite" label="Añadir motivo" icon="pi pi-plus"
                    (click)="editReason(null)" />
            </div>
            <p-table styleClass="mt-4" #grid [value]="casesServicesReasons" [lazy]="true" (onLazyLoad)="loadReasons($event)"
                [loading]="loading" [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
                        <!-- eliminado, es el mismo tipo que la cabcerea<th pSortableColumn="caseServiceReasonType">Tipo <p-sortIcon field="caseServiceReasonType"></p-sortIcon>
                        </th>-->
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-caseServiceReason let-columns="columns">
                    <tr (dblclick)="editReason(caseServiceReason)">
                        <td>{{caseServiceReason.name}}</td>
                        <!--<td>{{casesServicesReasonsService.getCaseServiceReasonTypeLabel(caseServiceReason.caseServiceReasonType)}}
                        </td>-->
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button *ngIf="allowDelete" (click)="deleteReason(caseServiceReason)" [rounded]="true" [text]="false"
                                    severity="danger"><i class="pi pi-trash"></i></p-button>
                                <p-button *ngIf="allowWrite" (click)="editReason(caseServiceReason)" [rounded]="true" [text]="false"><i
                                        class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>
        </p-tabPanel>
    </p-tabView>

</form>
<p-confirmDialog></p-confirmDialog>